import { Component } from 'solid-js';
import { useLanguage } from '../i18n/LanguageContext';

const CVPage: Component = () => {
  const { t, language } = useLanguage();

  const getCvUrl = () => {
    return language() === 'en' ? '/CV/en-cv.html' : '/CV/fr-cv.html';
  };

  return (
    <section class="cv-page">
      <div class="container">
        <h1 class="page-title">{t('cv.title')}</h1>

        <div class="cv-content">
          <div class="cv-embed-container">
            <iframe
              src={getCvUrl()}
              class="cv-iframe"
              title={t('cv.title')}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default CVPage;
